export default {
    moves: 'Ходове',
    time: 'Време',
    score: 'Точки',
    settings: 'Настройки',
    sounds: 'Звук',
    autocomplete: 'Автоматично завършване',
    leftHanded: 'За левичари',
    newDeal: 'Ново раздаване',
    design: 'Персонализиране',
    easy: 'Лесно',
    medium: 'Средно',
    hard: 'Трудно',
    expert: 'Експерт',
    master: 'Майстор',
    random: 'Случайно',
    rulesKlondikeURL: 'https://solitaires.com/bg/articles/how-to-play-solitaire/',
    cardHighlight: 'Осветяване на картите',
    rulesSpiderURL: 'https://solitaires.com/bg/articles/how-to-play-spider-solitaire/',
    rulesFreecellURL: 'https://solitaires.com/bg/articles/how-to-play-freecell-solitaire/',
    autoPlay: 'Автоматична игра',
    noMagicNeeded: 'Не ви е нужна Магическа пръчка — продължете играта сами!',
    leaveFeedback: 'Оставете отзив',
    feedbackThankYou: 'Благодарим ти за мнението!',
    feedbackError: 'Възникна грешка. Вашето съобщение не беше изпратено.',
    thanksSubscribing: 'Благодарим за абонамента!',
};
